import { ButtonGroup, LabeledTextInput } from '../../../../../../generic';
import Button from '../../../../../../generic/Button';

// domainIsValid is a super minimal validator for domains, requiring only that the domain have more than two characters
// and a dot. We rely on the backend for more thorough validation.
const domainIsValid = (domain: string): boolean =>
  domain.trim().length > 2 && domain.includes('.');

type EnterDomainStepBodyProps = {
  domain: string;
  setDomain(domain: string): void;
};

export const EnterDomainStepBody = ({ domain, setDomain }: EnterDomainStepBodyProps) => (
  <>
    <p className="margin-bottom-md">
      To claim a new domain for SSO, you must verify that you own the domain. Enter the domain you’d like to claim.
    </p>
    <LabeledTextInput label="Domain to claim" value={domain} onChange={setDomain} />
  </>
);

type EnterDomainStepButtonsProps = {
  domain: string;
  onCancel(): void;
  onNextStep(): void;
};

export const EnterDomainStepButtons = ({ domain, onCancel, onNextStep }: EnterDomainStepButtonsProps) => (
  <ButtonGroup>
    <Button type="secondary" onClick={onCancel}>
      Cancel
    </Button>
    <Button onClick={onNextStep} isDisabled={!domainIsValid(domain)}>
      Continue
    </Button>
  </ButtonGroup>
);
